import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'reactstrap';
import { TABLE_PAGE_SIZE_OPTIONS } from '../../hooks/useStoredTablePageSize';

const TablePageSizeSelect = ({ value, onChange, className }) => (
  <div className={className}>
    <Input
      type="select"
      value={value}
      onChange={e => onChange(Number(e.target.value))}
      className="med-table-page-size-input"
      aria-label="Jadvaldagi qatorlar soni"
    >
      {TABLE_PAGE_SIZE_OPTIONS.map(option => (
        <option key={option} value={option}>
          {option} ta
        </option>
      ))}
    </Input>
  </div>
);

TablePageSizeSelect.propTypes = {
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string
};

TablePageSizeSelect.defaultProps = {
  className: ''
};

export default TablePageSizeSelect;
